var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.677303 67.123741",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-66.444284,-121.11155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g33547-6",
    transform: "matrix(1.6140175,-0.09065623,0.08172938,1.7903078,-394.29905,-251.69108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33533-8",
    d: "m 297.54978,260.68432 c -2.82971,-16.50351 -0.85335,-36.46824 -0.85335,-36.46824 l 3.95073,1.09584 -0.0265,1.08393 3.93293,0.58809 0.0449,0.80527 3.39936,2.43325 -3.40904,1.97206 -0.0936,0.99984 -4.22902,0.43707 -0.0168,1.35556 -4.15581,1.18346",
    style: {
      fill: "#37abc8",
      stroke: "#87cdde",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33535-9",
    d: "m 300.61374,226.84409 -0.35403,6.28989",
    style: {
      fill: "none",
      stroke: "#5fbcd3",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33537-5",
    d: "m 303.8069,227.37283 0.0288,5.42465",
    style: {
      fill: "none",
      stroke: "#5fbcd3",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff2a2a",
      stroke: "#ff8080"
    },
    id: "g33547-5-7",
    transform: "matrix(1.6140175,-0.09065623,0.08172938,1.7903078,-391.59803,-218.0259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g33584-4",
    transform: "translate(-21.8616,-20.238635)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff2a2a",
      stroke: "#ff8080",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 294.05517,259.07696 c 2.45736,-14.98418 2.64126,-34.86088 2.64126,-34.86088 l 3.95073,1.09584 -0.0265,1.08393 3.93293,0.58809 0.0449,0.80527 3.39936,2.43325 -3.40904,1.97206 -0.0936,0.99984 -4.22902,0.43707 -0.0168,1.35556 -4.15581,1.18346",
    id: "path33533-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff2a2a",
      stroke: "#ff5555",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 300.61374,226.84409 -0.35403,6.28989",
    id: "path33535-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff2a2a",
      stroke: "#ff5555",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 303.8069,227.37283 0.0288,5.42465",
    id: "path33537-1-8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.8b8ebd0cbd059f9727762614a661b0bb.svg";
export { ForwardRef as ReactComponent };